// extracted by mini-css-extract-plugin
export default {"CheckboxGroup":"QhSXNzqP"};